module.exports = __webpack_public_path__ + "static/media/company.c0f50699.svg";